import { GeneralSetting } from '@apis/index'
import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import styled from '@emotion/styled'
import theme from '@utils/theme'
import { Form, Formik } from 'formik'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const games = ['pubg', 'freefire']

interface RuleFormProps {
  title: 'Admin' | 'Player'
  isActive?: boolean
}

const RuleForm = ({ title, isActive }: RuleFormProps) => {
  const group = `${title.toLowerCase()}-rule`
  const stateKey = `${title.toLowerCase()}Rules`

  const rules = useSelector((state: any) =>
    Array.isArray(state[stateKey]?.data) ? state[stateKey].data : [],
  )
  const [initialValues, setInitialValues] = useState({
    pubg: '',
    freefire: '',
  })

  useEffect(() => {
    const fetchRules = async () => {
      await GeneralSetting.getByGroup({
        id: group,
        state: stateKey,
      })
    }

    if (isActive) {
      fetchRules()
    }
  }, [isActive])

  useEffect(() => {
    const getValue = (game: string) => {
      const item = rules.find((r: any) => r.key === `${group}-${game}`)
      return typeof item?.value === 'string' ? item.value : ''
    }

    setInitialValues({
      pubg: getValue('pubg'),
      freefire: getValue('freefire'),
    })
  }, [rules])

  const handleSubmit = (game: 'pubg' | 'freefire') => async (values: any) => {
    try {
      const uniqueKey = `${group}-${game}`
      const existingRule = rules.find((r: any) => r.key === uniqueKey)

      const payload = {
        group,
        key: uniqueKey,
        value: values[game],
      }

      if (existingRule) {
        await GeneralSetting.update({
          id: existingRule.id,
          data: payload,
          state: stateKey,
        })
      } else {
        await GeneralSetting.create({
          data: payload,
          state: stateKey,
        })
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Fragment>
      <Column>
        {games.map((game) => (
          <Fragment key={`${group}-${game}`}>
            <StyleRuleTitle>
              {title} Rules for {game.charAt(0).toUpperCase() + game.slice(1)}
            </StyleRuleTitle>

            <Formik
              initialValues={{ [game]: initialValues[game] }}
              enableReinitialize
              onSubmit={handleSubmit(game as 'pubg' | 'freefire')}
            >
              <Form>
                <Column>
                  <Fields.Editor name={game} />
                  <Button
                    title="Save"
                    justify="end"
                    width={14}
                    height={43}
                    type="submit"
                  />
                </Column>
              </Form>
            </Formik>
          </Fragment>
        ))}
      </Column>
    </Fragment>
  )
}

export default RuleForm

const StyleRuleTitle = styled.p`
  color: ${theme.colors.primary};
  font-size: 18px;
`
